window.mobileTrigger = window.innerWidth < 992;

console.log('root.js jQuery status is', window.$);

var dateNum = new Date();
dateNum = `${dateNum.getDay()}${dateNum.getMonth()}${dateNum.getFullYear()}${(Math.random() * 1000).toFixed(0)}`;

$(window).resize(function(){
    window.mobileTrigger = window.innerWidth < 992;
    // $(document.body).attr('style', `--container: -${$('container').offset().left}px`);
});

$(function () {
    console.log('root.js defer jQuery status is', window.$);

    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
})

window.screenType = $(window).width() <= 992 ? 'mobile' : 'desktop';
$(document).ready(function(){
    if (window.screenType == 'mobile'){
        setWindowH();
    }
})

$(window).resize(function(){
    isSameScreen = $(window).width() <= 992 ? 'mobile' : 'desktop';

    if (window.screenType == isSameScreen) return;

    window.screenType = $(window).width() <= 992 ? 'mobile' : 'desktop';

    clearTimeout($.data(this, 'resizeTimer'));
    $.data(this, 'resizeTimer', setTimeout(function() {
        if (window.screenType == 'mobile')  setWindowH();
    }, 10));
});
$(window).scroll(function() {
    if (window.screenType == 'mobile') setWindowH();
})

function setWindowH(){
    document.documentElement.style.setProperty('--app-h', `${window.innerHeight}px`);
}

$(document).on('show.bs.modal', function(){
    $('html, body').addClass('modal-open');
})
$(document).on('hide.bs.modal', function(){
    $('html, body').removeClass('modal-open');
})

$(document).on('click', '[data-open]' ,function(e){
    e.preventDefault();
    e.stopPropagation();

    const target = $(this).attr('data-open');

    $(target).toggleClass('opened');
})


function drawValueDirection() {
    $(".js-draw-arrows").each(function (index) {
        $(this).toggleClass('decrease-arrow decrease', parseFloat($(this).text().replace(/\$/g, '')) < 0)
            .toggleClass('increase-arrow increase', parseFloat($(this).text().replace(/\$/g, '')) > 0);
    })
}